// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItems_meal__2dN5U","description":"MealItems_description__pvFNj","price":"MealItems_price__J9fl6","meal-image":"MealItems_meal-image__3iYi9"};